var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.875a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM8.562 12h6.876c1.139 0 2.062.923 2.062 2.063 0 1.534-.631 2.764-1.667 3.595-1.019.818-2.385 1.217-3.833 1.217-1.448 0-2.814-.399-3.833-1.217-1.036-.831-1.667-2.06-1.667-3.596C6.5 12.925 7.423 12 8.562 12ZM12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM2.375 12a9.625 9.625 0 1 1 19.25 0 9.625 9.625 0 0 1-19.25 0Z",
    fill: "#666"
  })));
};
export default SvgProfile;